<div class="searchResults">
  <div class="zeroPadding" *ngFor="let visitorCardStub of visitorCardStubs">
    <div
      class="row searchResultsRow"
      (click)="selectVisitorCardStub(visitorCardStub)"
    >
      <div class="col-md-11">
        <div class="searchResultName">
          <div>{{ visitorCardStub.name }}</div>
        </div>
        <div class="searchResultDataName">
          Location:
          <span class="searchResultDataVal">{{
            visitorCardStub.shipName
          }}</span>
          | Card Num:
          <span class="searchResultDataVal">{{ visitorCardStub.cardSeq }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
